import {
  ApiCartDeleteCartFailedAction,
  ApiCartDeleteCartSucceededAction,
  apiCartDeleteCartFailedType,
  apiCartDeleteCartRequested,
  apiCartDeleteCartSucceededType
} from '../../api/cart/deleteCartApi';
import {
  DeleteCurrentCartRequestedAction,
  deleteCurrentCartFailed,
  deleteCurrentCartSucceeded
} from '../../carts/cartsSlice';
import { put, race, take } from 'typed-redux-saga';
import generateActionId from '../../../generateActionId';

function* deleteCurrentCartSaga({
  payload: { actionId: requestedActionId, customOrderType }
}: DeleteCurrentCartRequestedAction): Generator {
  const actionId: number = generateActionId();

  yield* put(
    apiCartDeleteCartRequested({
      actionId,
      customOrderType,
      parentActionId: requestedActionId
    })
  );

  let isSameActionId: boolean = false;
  do {
    const { succeeded, failed } = yield* race({
      succeeded: take<ApiCartDeleteCartSucceededAction>(apiCartDeleteCartSucceededType),
      failed: take<ApiCartDeleteCartFailedAction>(apiCartDeleteCartFailedType)
    });

    isSameActionId =
      succeeded?.payload.requestedActionId === actionId ||
      failed?.payload.requestedActionId === actionId;

    if (isSameActionId) {
      if (succeeded !== undefined) {
        yield* put(
          deleteCurrentCartSucceeded({
            cartId: succeeded.payload.cartId,
            customOrderType,
            requestedActionId
          })
        );
      } else if (failed !== undefined) {
        yield* put(deleteCurrentCartFailed({ requestedActionId }));
      }
    }
  } while (!isSameActionId);
}

export default deleteCurrentCartSaga;
